module.exports = __webpack_public_path__ + "img/aqfh-img-24.28fdc2d6.png";